<template>
  <div class="cadastrar-noticia">
    <!-- NAVBAR DE NAVEGAÇÃO -->
    <nav class="header-nav">
      <div class="nav-content">
        <router-link
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="nav-item"
          active-class="nav-item--active"
        >
          <svg
            v-if="item.icon === 'search'"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            width="16"
            height="16"
          >
            <circle
              cx="11"
              cy="11"
              r="7"
            />
            <line
              x1="16.5"
              y1="16.5"
              x2="22"
              y2="22"
            />
          </svg>
          <span v-else>{{ item.label }}</span>
        </router-link>
      </div>
    </nav>
    <breadcrumb :items="breadcrumbItems" />

    <h2 class="page-title">Cadastrar Nova Notícia:</h2>

    <div class="form-layout">
      <div class="col-left">
        <div class="field-group">
          <label class="field-label required"
            >Título
            <span
              class="help-icon"
              title="Informe o título da notícia"
              >?</span
            ></label
          >
          <input
            v-model="form.titulo"
            type="text"
            class="field-input"
          />
        </div>

        <div class="field-group">
          <label class="field-label required"
            >Fonte
            <span
              class="help-icon"
              title="Informe a fonte da notícia"
              >?</span
            ></label
          >
          <input
            v-model="form.fonte"
            type="text"
            class="field-input"
          />
        </div>

        <div class="field-group">
          <label class="field-label"
            >Imagem (Opcional)
            <span
              class="help-icon"
              title="Selecione uma imagem opcional"
              >?</span
            ></label
          >
          <div class="file-upload">
            <label
              class="btn-escolher"
              @click="triggerFileInput"
              >Escolher arquivo</label
            >
            <input
              ref="fileInput"
              type="file"
              accept="image/*"
              style="display: none"
              @change="handleFileChange"
            />
            <span class="file-name">{{
              form.imagemNome || "Nenhum arquivo escolhido"
            }}</span>
          </div>
        </div>

        <div
          v-if="imagemSelecionada"
          class="field-group"
        >
          <label class="field-label required"
            >Descrição da Imagem
            <span
              class="help-icon"
              title="Informe uma breve descrição da imagem para acessibilidade"
              >?</span
            ></label
          >
          <input
            v-model="form.descricaoImagem"
            type="text"
            class="field-input"
            placeholder="Ex: Grupo de extensão em um evento"
          />
        </div>

        <div class="field-group">
          <label class="field-label required"
            >Palavras-chave
            <span
              class="help-icon"
              title="Adicione palavras-chave"
              >?</span
            ></label
          >
          <div class="keywords-input">
            <input
              v-model="keywordInput"
              type="text"
              class="field-input keyword-field"
              @keyup.enter="adicionarPalavra"
              placeholder=""
            />
            <button
              class="btn-adicionar"
              @click="adicionarPalavra"
            >
              Adicionar
            </button>
          </div>
          <div
            v-if="form.palavrasChave.length > 0"
            class="keywords-tags"
          >
            <span
              v-for="(palavra, index) in form.palavrasChave"
              :key="index"
              class="keyword-tag"
            >
              {{ palavra }}
              <button
                class="tag-remove"
                @click="removerPalavra(index)"
              >
                ×
              </button>
            </span>
          </div>
        </div>

        <div class="field-group">
          <label class="field-label required"
            >Abrangência
            <span
              class="help-icon"
              title="Selecione a abrangência"
              >?</span
            ></label
          >
          <div class="radio-group">
            <label
              v-for="abrangencia in abrangencias"
              :key="abrangencia.id"
              class="radio-label"
            >
              <input
                v-model="form.abrangenciaId"
                type="radio"
                :value="abrangencia.id"
              />
              <span class="radio-custom"></span>
              {{ abrangencia.abrangencia.toUpperCase() }}
            </label>
          </div>
        </div>
      </div>

      <div class="col-right">
        <div class="field-group full-height">
          <label class="field-label required"
            >Texto
            <span
              class="help-icon"
              title="Informe o texto da notícia"
              >?</span
            ></label
          >
          <div class="editor-wrapper">
            <div class="editor-toolbar">
              <button
                class="toolbar-btn"
                title="Negrito"
              >
                <strong>B</strong>
              </button>
              <button
                class="toolbar-btn italic-btn"
                title="Itálico"
              >
                <em>I</em>
              </button>
              <button
                class="toolbar-btn underline-btn"
                title="Sublinhado"
              >
                <u>U</u>
              </button>
              <button
                class="toolbar-btn"
                title="Cor do texto"
              >
                A▾
              </button>
              <div class="toolbar-divider"></div>
              <button
                class="toolbar-btn"
                title="Alinhar à esquerda"
              >
                ≡
              </button>
              <button
                class="toolbar-btn"
                title="Centralizar"
              >
                ≡
              </button>
              <button
                class="toolbar-btn"
                title="Alinhar à direita"
              >
                ≡
              </button>
              <button
                class="toolbar-btn"
                title="Justificar"
              >
                ≡
              </button>
            </div>
            <textarea
              v-model="form.texto"
              class="editor-textarea"
              placeholder=""
            ></textarea>
          </div>
        </div>

        <div class="publish-section">
          <div class="publish-row">
            <div class="field-group date-group">
              <label class="field-label"
                >Data de publicação
                <span
                  class="help-icon"
                  title="Data de publicação"
                  >?</span
                ></label
              >
              <div class="date-input-wrapper">
                <input
                  v-model="form.dataPublicacao"
                  type="date"
                  class="field-input date-input"
                  placeholder="DD/MM/AAAA"
                  :min="dataMinimaPublicacao"
                  :max="dataMaximaPublicacao || undefined"
                />
              </div>
            </div>
            <button
              class="btn-publicar"
              @click="publicar"
            >
              {{ isAgendamento ? "Agendar" : "Publicar" }}
            </button>
          </div>
          <span
            v-if="mostrarErro"
            class="mensagem-erro"
          >
            Dados insuficientes! Preencha os campos obrigatórios (*)
          </span>
          <span
            v-if="erroData"
            class="mensagem-erro"
          >
            {{ erroData }}
          </span>
        </div>
      </div>
    </div>

    <div
      v-if="modal.visivel"
      class="modal-overlay"
      @click.self="fecharModal"
    >
      <div class="modal-box">
        <div class="modal-header">
          <span>AVISO</span>
          <button
            class="modal-close"
            @click="fecharModal"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-icon">
            <svg
              viewBox="0 0 52 52"
              class="checkmark-svg"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="26"
                cy="26"
                r="25"
                fill="#4caf50"
              />
              <path
                d="M14 27 L22 35 L38 19"
                stroke="white"
                stroke-width="3.5"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <p class="modal-message">{{ modal.mensagem }}</p>
          <button
            class="modal-ok"
            @click="fecharModal"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  onMounted,
  onBeforeUnmount,
  defineProps,
  defineEmits,
  computed,
} from "vue";
import { useRoute } from "vue-router";
import acaoService from "@/service/acaoService";
import atividadeService from "@/service/atividadeService";
import noticiaService from "@/service/noticiaService";
import router from "@/router";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

dayjs.extend(utc);
dayjs.extend(timezone);

const props = defineProps({
  acaoId: {
    type: String,
    default: null,
  },
  atividadeObjeto: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(["fechar-form-noticia"]);
const atividade = ref({});
const route = useRoute();
const navItems = [
  { label: "Minhas ações", path: "/suas-acoes" },
  { label: "Atividades", path: "/atividades" },
  { label: "Notícias", path: "/noticias" },
  { label: "Vagas de Extensão", path: "/vagas" },
  { label: "Parcerias", path: "/parcerias" },
  {
    label: "Certificados e Declarações",
    path: "/Meus-Certificados-e-Declaracoes",
  },
  { icon: "search", path: "/busca" },
];
const fileInput = ref(null);
const keywordInput = ref("");
const dadosAcao = ref(null);
const abrangencias = ref([]);
const autor = reactive({ id: null, nome: "" });
const imagemSelecionada = ref(false);
const mostrarErro = ref(false);
const erroData = ref("");

const breadcrumbItems = computed(() => {
  const acaoId = route.params.id;

  let items = [
    { label: "Início", to: "/" },
    { label: "Ações", to: "/suas-acoes" },
    { tipo: "acao", id: acaoId, to: `/acao/${acaoId}` },
  ];

  if (atividade.value?.nome) {
    items = [
      ...items,
      {
        label: "Cadastrar Atividade",
        to: `/acao/${acaoId}/cadastrar-atividade`,
      },
      { label: "Cadastrar Notícia", to: `/acao/${acaoId}/cadastrar-noticia` },
    ];
  } else {
    items = [
      ...items,
      { label: "Cadastrar Notícia", to: `/acao/${acaoId}/cadastrar-noticia` },
    ];
  }

  return items;
});

const form = reactive({
  titulo: "",
  dataPublicacao: dayjs().format("YYYY-MM-DD"),
  texto: "",
  fonte: "",
  descricaoImagem: "",
  palavrasChave: [],
  abrangenciaId: null,
  imagemNome: "",
  imagem: {
    mimeType: "",
    base64Data: "",
  },
});

const modal = reactive({
  visivel: false,
  mensagem: "",
  tipo: "", // 'publicada' | 'avaliacao'
});

const isAgendamento = computed(() => {
  if (!form.dataPublicacao) return false;
  const hoje = dayjs().startOf("day");
  const dataPub = dayjs(form.dataPublicacao).startOf("day");
  return dataPub.isAfter(hoje);
});

const dataMinimaPublicacao = computed(() => dayjs().format("YYYY-MM-DD"));

const dataMaximaPublicacao = computed(() => {
  if (
    atividade.value?.modalidadeInscricao === "NESCESSITA_INSCRICAO" &&
    atividade.value?.dataFimInscricao
  ) {
    return dayjs(atividade.value.dataFimInscricao).format("YYYY-MM-DD");
  }
  return undefined;
});

let acaoAoFecharModal = null;

function abrirModal(tipo, mensagemCustomizada = "") {
  if (mensagemCustomizada) {
    modal.mensagem = mensagemCustomizada;
  } else if (tipo === "publicada") {
    modal.mensagem = isAgendamento.value
      ? "Notícia agendada com sucesso!"
      : "Notícia publicada com sucesso!";
  } else {
    modal.mensagem = "Sua notícia foi enviada para avaliação!";
  }
  modal.tipo = tipo;
  modal.visivel = true;
}

function fecharModal() {
  modal.visivel = false;
  if (acaoAoFecharModal) {
    acaoAoFecharModal();
    acaoAoFecharModal = null;
  }
}

function triggerFileInput() {
  fileInput.value.click();
}

function handleFileChange(event) {
  const file = event.target.files[0];
  if (file) {
    form.imagemNome = file.name;
    const extensao = file.name.split(".").pop().toLowerCase();
    const extensoesPermitidas = ["png", "jpg", "jpeg"];

    if (!extensoesPermitidas.includes(extensao)) {
      alert("Arquivo não permitido. Use PNG, JPG ou JPEG.");
      return;
    }

    form.imagem.mimeType = file.type;
    const leitor = new FileReader();
    leitor.readAsDataURL(file);
    leitor.onload = () => {
      form.imagem.base64Data = leitor.result.split(",")[1];
      imagemSelecionada.value = true;
    };
  }
}

function adicionarPalavra() {
  const palavra = keywordInput.value.trim();
  if (palavra !== "") {
    const palavras = palavra
      .split(/[;,]+/)
      .map((p) => p.trim())
      .filter((p) => p !== "" && !form.palavrasChave.includes(p));

    if (palavras.length > 0) {
      form.palavrasChave.push(...palavras);
      keywordInput.value = "";
    } else if (form.palavrasChave.includes(palavra)) {
      alert("Não é permitido palavras repetidas");
    }
  } else {
    alert("A palavra chave não pode ser vazia");
  }
}

function removerPalavra(index) {
  form.palavrasChave.splice(index, 1);
}

function toUTC(date) {
  if (!date) return null;
  const d = dayjs(date);
  if (!d.isValid()) return date;
  return d.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
}

function publicar() {
  mostrarErro.value = false;
  erroData.value = "";

  if (
    !form.titulo?.trim() ||
    !form.fonte?.trim() ||
    form.palavrasChave.length === 0 ||
    !form.abrangenciaId ||
    !form.texto?.trim() ||
    !form.dataPublicacao ||
    (imagemSelecionada.value && !form.descricaoImagem?.trim())
  ) {
    mostrarErro.value = true;
    return;
  }

  const hoje = dayjs().startOf("day");
  const dataPub = dayjs(form.dataPublicacao).startOf("day");

  // Critério 3: Verificar se o sistema não permite criar uma notícia com uma data anterior a data atual
  if (dataPub.isBefore(hoje)) {
    erroData.value =
      "Não é permitido criar uma notícia com data de publicação anterior à data atual.";
    return;
  }

  // Critério 4: Verificar se o sistema não permite criar uma notícia com uma data posterior a data de término de inscrição da atividade (caso possua)
  if (
    atividade.value?.modalidadeInscricao === "NESCESSITA_INSCRICAO" &&
    atividade.value?.dataFimInscricao
  ) {
    const dataFimInscricao = dayjs(atividade.value.dataFimInscricao).endOf("day");
    if (dataPub.isAfter(dataFimInscricao)) {
      erroData.value =
        "Não é permitido criar uma notícia com data de publicação posterior à data de término de inscrição da atividade.";
      return;
    }
  }

  const abrangenciaSelecionada = abrangencias.value.find(
    (a) => a.id === form.abrangenciaId
  );
  const abrangenciaNome =
    abrangenciaSelecionada?.abrangenciaNoticia?.toLowerCase() ||
    abrangenciaSelecionada?.abrangencia?.toLowerCase() ||
    "";

  if (abrangenciaNome.includes("unidade") || abrangenciaNome.includes("prex")) {
    const diffDays = dataPub.diff(hoje, "day");

    if (diffDays < 7) {
      erroData.value =
        "Deve haver pelo menos um período de 7 dias em relação a criação da notícia e sua data de publicação para que o coordenador de extensão possa avaliá-la";
      return;
    }
  }

  enviarNoticia();
}

async function enviarNoticia() {
  try {
    const acaoId = route.params.id || props.acaoId;

    if (!acaoId) {
      return alert(
        "Erro: ID da ação não encontrado. Certifique-se de que está acessando a página corretamente."
      );
    }

    if (!autor.id) {
      return alert(
        "Erro: Não foi possível identificar o autor da notícia. Verifique sua conexão ou tente recarregar a página."
      );
    }

    const abrangenciaSelecionada = abrangencias.value.find(
      (a) => a.id === form.abrangenciaId
    );

    if (!abrangenciaSelecionada && abrangencias.value.length === 0) {
      return alert(
        "Erro: As opções de abrangência não foram carregadas. Tente recarregar a página."
      );
    }

    const abrangenciaNome =
      abrangenciaSelecionada?.abrangenciaNoticia?.toLowerCase() ||
      abrangenciaSelecionada?.abrangencia?.toLowerCase() ||
      "";

    const isAcao = abrangenciaNome.includes("acao");
    const tipoModal = isAcao ? "publicada" : "avaliacao";

    const payloadNoticia = {
      titulo: form.titulo,
      dataPublicacao: toUTC(form.dataPublicacao),
      texto: form.texto,
      fonte: form.fonte,
      palavrasChaves: [...form.palavrasChave],
      dataAutorizacao: toUTC(new Date()),
      abrangenciaId: form.abrangenciaId || abrangencias.value[0]?.id,
      autorId: autor.id,
      imagem: form.imagem.base64Data !== "" ? {
        mimeType: form.imagem.mimeType || "image/png",
        base64Data: form.imagem.base64Data,
        creditosImagem: form.imagem.creditosImagem || "",
      } : null,
      descricaoImagem: form.descricaoImagem || "",
    };

    if (atividade.value?.nome) {
      // Caso: Cadastro de atividade integrada com notícia (Conforme DTO)
      const atividadeObj = atividade.value;
      const targetAcaoId = acaoId || atividadeObj.acaoExtensaoId;

      const payloadAtividade = {
        nome: atividadeObj.nome,
        descricao: atividadeObj.descricao,
        subtipo_id: Number(atividadeObj.subtipo_id),
        modalidadeExecucao: atividadeObj.modalidadeExecucao,
        modalidadeInscricao: atividadeObj.modalidadeInscricao,
        local: atividadeObj.local,
        acaoExtensaoId: targetAcaoId,
        dataInicioInscricao:
          atividadeObj.modalidadeInscricao === "NESCESSITA_INSCRICAO" &&
          atividadeObj.dataInicioInscricao
            ? toUTC(atividadeObj.dataInicioInscricao)
            : null,
        dataFimInscricao:
          atividadeObj.modalidadeInscricao === "NESCESSITA_INSCRICAO" &&
          atividadeObj.dataFimInscricao
            ? toUTC(atividadeObj.dataFimInscricao)
            : null,
        criterioInscricao:
          atividadeObj.modalidadeInscricao === "NESCESSITA_INSCRICAO"
            ? atividadeObj.criterioInscricao
            : null,
        numeroDeVagasOfertadas:
          atividadeObj.modalidadeInscricao === "NESCESSITA_INSCRICAO"
            ? Number(atividadeObj.numeroDeVagasOfertadas) || 0
            : null,
        linkFormulario: atividadeObj.linkFormulario || "",
        criarNoticia: true,
        objetivos: Array.isArray(atividadeObj.objetivos)
          ? [...atividadeObj.objetivos]
          : [],
        encontros: Array.isArray(atividadeObj.encontros)
          ? atividadeObj.encontros.map((e) => ({
              titulo: e.titulo,
              descricao: e.descricao,
              inicio_periodo: toUTC(e.inicio_periodo),
              fim_periodo: toUTC(e.fim_periodo),
            }))
          : [],
        noticia: payloadNoticia,
        imagem: atividadeObj.imagem?.base64Data
          ? {
              mimeType: atividadeObj.imagem.mimeType || "image/png",
              base64Data: atividadeObj.imagem.base64Data,
              creditosImagem: atividadeObj.imagem.creditosImagem || "",
            }
          : null,
        palavrasChave: Array.isArray(atividadeObj.palavrasChave)
          ? [...atividadeObj.palavrasChave]
          : [],
      };

      if (atividadeObj.dataInicioRealizacao) {
        payloadAtividade.dataInicioRealizacao = toUTC(
          atividadeObj.dataInicioRealizacao
        );
      }
      if (atividadeObj.dataFimRealizacao) {
        payloadAtividade.dataFimRealizacao = toUTC(
          atividadeObj.dataFimRealizacao
        );
      }

      const resposta = await atividadeService.postAtividade(payloadAtividade);

      sessionStorage.removeItem("atividade-em-cadastro");
      sessionStorage.removeItem("cadastro-atividade-temp");

      const finalAtividadeId = resposta?.id || resposta?.atividadeId;
      acaoAoFecharModal = () => {
        if (targetAcaoId && finalAtividadeId) {
          router.push(`/acao/${targetAcaoId}/atividades/${finalAtividadeId}`);
        } else {
          router.push(`/acao/${targetAcaoId}/atividades`);
        }
        emit("fechar-form-noticia");
      };
      abrirModal(tipoModal, "Notícia e atividade cadastradas com sucesso!");
    } else {
      await noticiaService.postNoticiaAcao(payloadNoticia, acaoId);

      acaoAoFecharModal = () => {
        router.push(`/acao/${acaoId}/noticias`);
        emit("fechar-form-noticia");
      };
      abrirModal(tipoModal);
    }
  } catch (error) {
    console.error("Erro detalhado ao enviar notícia:", error);

    let mensagemErro = "Erro ao enviar notícia.";

    if (error.response) {
      const data = error.response.data;
      if (data && data.message) {
        mensagemErro += `\nMotivo: ${data.message}`;
      } else if (typeof data === "string" && data.length < 100) {
        mensagemErro += `\nMotivo: ${data}`;
      } else {
        mensagemErro += `\nStatus: ${error.response.status} - ${error.response.statusText}`;
      }
    } else if (error.request) {
      mensagemErro += "\nO servidor não respondeu. Verifique sua conexão.";
    } else {
      mensagemErro += `\nErro: ${error.message}`;
    }

    alert(mensagemErro);
  }
}

async function carregarAcao() {
  const acaoId = route.params.id || props.acaoId;
  if (acaoId) {
    try {
      dadosAcao.value = await acaoService.getAcoesById(acaoId);
    } catch (error) {
      console.error("Erro ao carregar dados da ação:", error);
    }
  }
}

async function getAutor() {
  try {
    const response = await noticiaService.getAllAutorNoticia();
    if (response && response.length > 0) {
      autor.id = response[0].id;
      autor.nome = response[0].autoNoticia;
    }
  } catch (error) {
    console.error("Erro ao buscar autor:", error);
  }
}

async function buscarAbrangecias() {
  abrangencias.value = await noticiaService.getAllAbrangenciasNoticia();
  if (abrangencias.value && abrangencias.value.length > 0) {
    const abrangenciaAcao = abrangencias.value.find((a) => {
      const nome = (a.abrangenciaNoticia || a.abrangencia || "").toLowerCase();
      return nome.includes("acao") || nome.includes("ação");
    });
    if (!form.abrangenciaId) {
      form.abrangenciaId = abrangenciaAcao
        ? abrangenciaAcao.id
        : abrangencias.value[0]?.id;
    }
  }
}

function gerarTextoBaseNoticia(atv, acao) {
  const nomeAcao = acao?.titulo || "<Ação de extensão>";
  const nomeAtividade = atv?.nome || "<Título da Atividade>";
  const tipoAtividade =
    atv?.subtipoNome ||
    atv?.tipoNome ||
    "<Tipo da Atividade: Minicurso/Evento/Oficina/Roda de Conversa>";
  const temaPrincipal = "<Breve Destaque do Tema Principal>";

  let dataPrimeiroEncontro = "<Data do primeiro encontro>";
  if (atv?.encontros?.length > 0 && atv.encontros[0]?.inicio_periodo) {
    dataPrimeiroEncontro = dayjs(atv.encontros[0].inicio_periodo).format(
      "DD/MM/YYYY"
    );
  } else if (atv?.dataInicioRealizacao) {
    dataPrimeiroEncontro = dayjs(atv.dataInicioRealizacao).format("DD/MM/YYYY");
  }

  const localAtividade = atv?.local || "<Localização da atividade>";
  const publicoAlvo = "<Público-Alvo, se houver>";

  const descricaoAtividade =
    atv?.descricao && atv.descricao.trim()
      ? atv.descricao.trim()
      : `<Descrição detalhada – Explique o propósito, conteúdo e relevância. Exemplo: "Com foco em <Objetivo Relacionado>, a atividade promoverá <exemplos de dinâmicas, palestras ou resultados esperados>. Os participantes terão a oportunidade de <benefícios ou aprendizados>.">`;

  let modalidadeTexto = "";
  if (atv?.modalidadeInscricao === "NESCESSITA_INSCRICAO") {
    const dataInicio = atv?.dataInicioInscricao
      ? dayjs(atv.dataInicioInscricao).format("DD/MM/YYYY")
      : "<Data de Início>";
    const dataFim = atv?.dataFimInscricao
      ? dayjs(atv.dataFimInscricao).format("DD/MM/YYYY")
      : "<Data de Término>";

    let vagas = "<Número de Vagas>";
    if (
      atv?.numeroDeVagasOfertadas !== null &&
      atv?.numeroDeVagasOfertadas !== undefined &&
      atv?.numeroDeVagasOfertadas !== ""
    ) {
      vagas =
        Number(atv.numeroDeVagasOfertadas) === 0
          ? "Ilimitadas"
          : String(atv.numeroDeVagasOfertadas);
    }

    const criterio =
      atv?.criterioInscricao === "ORDEMDEINSCRICAO"
        ? "Ordem de Inscrição"
        : atv?.criterioInscricao === "CRITERIODACOORDENACAO"
        ? "Decisão da Coordenação"
        : "<Ordem de Inscrição/Decisão da Coordenação>";

    const linkForm = atv?.linkFormulario || "<Link para Formulário>";

    modalidadeTexto = `Com inscrição: As inscrições estão abertas de ${dataInicio} até ${dataFim}.

        Vagas: ${vagas} (preenchidas por ${criterio}).

         Caso haja formulário seletivo: Os interessados devem preencher o formulário disponível em ${linkForm}.`;
  } else if (
    atv?.modalidadeInscricao === "NAO_NESCESSITA_INSCRICAO_COM_FREQUENCIA"
  ) {
    modalidadeTexto = `Sem inscrição, mas com frequência registrada: Participação livre e gratuita! Basta comparecer no local e horário indicados.`;
  } else if (
    atv?.modalidadeInscricao === "NAO_NESCESSITA_INSCRICAO_SEM_FREQUENCIA"
  ) {
    modalidadeTexto = `Sem inscrição e sem frequência: Evento aberto – não há registro de participação.`;
  } else {
    modalidadeTexto = `Com inscrição: As inscrições estão abertas de <Data de Início> até <Data de Término>.

        Vagas: <Número de Vagas> (preenchidas por <Ordem de Inscrição/Decisão da Coordenação>).

         Caso haja formulário seletivo: Os interessados devem preencher o formulário disponível em <Link para Formulário>.

Sem inscrição, mas com frequência registrada: Participação livre e gratuita! Basta comparecer no local e horário indicados.

Sem inscrição e sem frequência: Evento aberto – não há registro de participação.`;
  }

  const localCompleto =
    atv?.local || "<Localização Completa + Link para mapa, se aplicável>";
  const emailCoord =
    acao?.emailCoordenador ||
    acao?.coordenador?.email ||
    acao?.email ||
    "<Email do coordenador extensionista>";

  return `O ${nomeAcao} tem o prazer de anunciar a atividade ${nomeAtividade}, que será um(a) ${tipoAtividade} que abordará ${temaPrincipal}. A ação será realizada no dia ${dataPrimeiroEncontro}, no ${localAtividade}, e é voltada para ${publicoAlvo}.

Sobre a Atividade:
${descricaoAtividade}

Modalidade de Participação:

${modalidadeTexto}

Informações Adicionais:

Local: ${localCompleto}

Não perca esta oportunidade! Para dúvidas, entre em contato com ${emailCoord}.`;
}

function analiseTipoInscricaoAtividade() {
  if (!props.atividadeObjeto) return "";
  return props.atividadeObjeto.modalidadeInscricao === "NESCESSITA_INSCRICAO"
    ? "Necessita de inscrição"
    : "Não necessita de inscrição";
}

onMounted(async () => {
  const atividadeSalva = sessionStorage.getItem("atividade-em-cadastro");

  if (atividadeSalva) {
    try {
      atividade.value = JSON.parse(atividadeSalva);
    } catch (e) {
      console.error("Erro ao ler dados da atividade do sessionStorage:", e);
    }
  } else if (props.atividadeObjeto) {
    atividade.value = props.atividadeObjeto;
  } else if (window.history.state?.atividadeObjeto) {
    atividade.value = window.history.state.atividadeObjeto;
  }

  await carregarAcao();
  await buscarAbrangecias();
  await getAutor();

  if (atividade.value?.nome) {
    if (!form.titulo) {
      form.titulo = atividade.value.nome;
    }
    if (
      form.palavrasChave.length === 0 &&
      Array.isArray(atividade.value.palavrasChave)
    ) {
      form.palavrasChave = [...atividade.value.palavrasChave];
    }
    if (!form.texto) {
      form.texto = gerarTextoBaseNoticia(atividade.value, dadosAcao.value);
    }

    if (atividade.value.imagem?.base64Data && !form.imagem.base64Data) {
      form.imagem = {
        mimeType: atividade.value.imagem.mimeType || "image/png",
        base64Data: atividade.value.imagem.base64Data,
        creditosImagem: atividade.value.imagem.creditosImagem || "",
      };
      if (atividade.value.imagem.descricaoImagem && !form.descricaoImagem) {
        form.descricaoImagem = atividade.value.imagem.descricaoImagem;
      }
      form.imagemNome = "Imagem da Atividade";
      imagemSelecionada.value = true;
    }
  }

  if (dadosAcao.value?.titulo && !form.fonte) {
    form.fonte = dadosAcao.value.titulo;
  }
});

onBeforeUnmount(() => {
  const layoutElement = document.getElementById("layout");
  if (layoutElement) layoutElement.classList.remove("layout-com-cadastro");
});
</script>

<style scoped>
.publish-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
  width: 100%;
}

.mensagem-erro {
  color: #e53935;
  font-size: 0.85rem;
  font-weight: 500;
  text-align: justify;
  width: 100%;
  display: block;
  word-wrap: break-word;
}

.header-nav {
  background: #d9d9d9;
  border-bottom: 1px solid #e0ddf0;
  margin: -24px -32px 24px -32px;
  padding: 0 48px;
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  box-sizing: border-box;
}

.nav-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 14px 0;
  font-size: 0.88rem;
  font-weight: 400;
  color: #333;
  text-decoration: none;
  border-bottom: 3px solid transparent;
  transition:
    color 0.2s,
    border-color 0.2s;
  white-space: nowrap;
}

.nav-item:hover {
  color: #4a3090;
  border-bottom-color: #c0b4e8;
}

.nav-item--active {
  color: #4a3090;
  border-bottom-color: #4a3090;
  font-weight: 600;
}

.cadastrar-noticia {
  font-family: var(--font-base);
  color: var(--preto);
}

.page-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: var(--preto);
  margin-bottom: 24px;
}

.form-layout {
  display: flex;
  gap: 32px;
  align-items: flex-start;
}

.col-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.col-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Field groups */
.field-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field-group.full-height {
  flex: 1;
}

.field-label {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--preto);
  display: flex;
  align-items: center;
  gap: 6px;
}

.field-label.required::before {
  content: "*";
  color: #5b3fa8;
}

.help-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #9e9e9e;
  color: var(--branco);
  font-size: 0.65rem;
  font-weight: bold;
  cursor: pointer;
}

.field-input {
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 0.9rem;
  color: var(--preto);
  outline: none;
  transition: border-color 0.2s;
  width: 100%;
  box-sizing: border-box;
}

.field-input:focus {
  border-color: #5b3fa8;
  box-shadow: 0 0 0 2px rgba(91, 63, 168, 0.12);
}

/* File upload */
.file-upload {
  display: flex;
  align-items: center;
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  overflow: hidden;
}

.btn-escolher {
  background: #5b3fa8;
  color: var(--branco);
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.2s;
}

.btn-escolher:hover {
  background: #4a3090;
}

.file-name {
  padding: 8px 12px;
  font-size: 0.85rem;
  color: #666;
  flex: 1;
  background: var(--branco);
}

/* Keywords */
.keywords-input {
  display: flex;
  gap: 8px;
}

.keyword-field {
  flex: 1;
}

.btn-adicionar {
  background: #5b3fa8;
  color: var(--branco);
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.btn-adicionar:hover {
  background: #4a3090;
}

.keywords-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 4px;
}

.keyword-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #ede9f8;
  color: #5b3fa8;
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 0.8rem;
  font-weight: 500;
}

.tag-remove {
  background: none;
  border: none;
  color: #5b3fa8;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
}

/* Radio */
.radio-group {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  padding: 10px 14px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--preto);
  cursor: pointer;
  position: relative;
}

.radio-label input[type="radio"] {
  accent-color: #5b3fa8;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.radio-custom {
  display: none;
}

/* Editor */
.editor-wrapper {
  border: 1px solid #c0bcd6;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 280px;
}

.editor-toolbar {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 10px;
  background: #f9f8fd;
  border-bottom: 1px solid #ddd;
}

.toolbar-btn {
  background: none;
  border: none;
  padding: 4px 7px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.85rem;
  color: var(--preto);
  transition: background 0.15s;
}

.toolbar-btn:hover {
  background: #ede9f8;
  color: #5b3fa8;
}

.toolbar-divider {
  width: 1px;
  height: 18px;
  background: #ddd;
  margin: 0 4px;
}

.editor-textarea {
  flex: 1;
  border: none;
  outline: none;
  padding: 12px;
  font-size: 0.9rem;
  font-family: inherit;
  resize: none;
  color: var(--preto);
  min-height: 230px;
  box-sizing: border-box;
}

/* Publish row */
.publish-row {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;
}

.date-group {
  flex-direction: column;
  gap: 4px;
}

.date-input-wrapper {
  position: relative;
}

.date-input {
  padding-right: 36px;
  min-width: 160px;
}

.btn-publicar {
  background: #5b3fa8;
  color: var(--branco);
  border: none;
  border-radius: 4px;
  padding: 10px 28px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.btn-publicar:hover {
  background: #4a3090;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-box {
  background: var(--branco);
  border-radius: 6px;
  min-width: 300px;
  max-width: 380px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.modal-header {
  background: #4a3090;
  color: var(--branco);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.04em;
}

.modal-close {
  background: #6d4fc4;
  border: none;
  color: var(--branco);
  font-size: 1.1rem;
  cursor: pointer;
  border-radius: 3px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.modal-close:hover {
  background: #3a2070;
}

.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 24px;
  gap: 16px;
}

.modal-icon {
  width: 56px;
  height: 56px;
}

.checkmark-svg {
  width: 100%;
  height: 100%;
}

.modal-message {
  font-size: 1rem;
  font-weight: 600;
  color: var(--preto);
  text-align: center;
  margin: 0;
}

.modal-ok {
  background: #5b3fa8;
  color: var(--branco);
  border: none;
  border-radius: 20px;
  padding: 8px 36px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 4px;
}

.modal-ok:hover {
  background: #4a3090;
}

/* Responsive */
@media (max-width: 768px) {
  .form-layout {
    flex-direction: column;
  }

  .col-left {
    flex: unset;
    width: 100%;
  }

  .publish-row {
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>
